var map = {
	"./border-1.png": "17fa",
	"./border-2.png": "cbc8",
	"./border-3.png": "1298",
	"./border-4.png": "2f45",
	"./border-5.png": "f203",
	"./border-6.png": "b76d",
	"./character-1.png": "71c3",
	"./character-2.png": "d532",
	"./character-3.png": "02ab",
	"./character-4.png": "e387",
	"./character-5.png": "9296",
	"./character-6.png": "4499",
	"./item-1.png": "e47d",
	"./item-2.png": "1d83",
	"./item-3.png": "8406",
	"./item-4.png": "d8ec",
	"./item-5.png": "a2b0",
	"./net-border-1.png": "638c",
	"./net-border-2.png": "547f",
	"./net-border-3.png": "d990",
	"./net-border-4.png": "8e4e",
	"./net-border-5.png": "227d",
	"./net-border-6.png": "e9d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a902";